import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { followupList } from "reduxStore/action/followUpActions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";

const AllFollowUp = () => {
  const navigate = useNavigate();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const dispatch = useDispatch();
  const [viewData, setViewData] = useState({});
  const params = useParams();
  const { lead_id = "" } = params || {};
  const allFollowupDetail = useSelector((state) => state.followUp) || {};

  useEffect(() => {
    if (allFollowupDetail.response) {
      const { response } = allFollowupDetail;
      if (response?.status === 200) {
        setViewData(response.data);
      }
    }
  }, [allFollowupDetail]);

  useEffect(() => {
    dispatch(followupList({ lead_id: lead_id }));
  }, []);
  useEffect(() => {
    seo({
      title: "All Followup",
      metaDescription: "All followup",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.allFollowup}
        url={"/followup"}
        parentListing={strings.followupList}
        titleactive={strings.allfollowup}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div>
              {viewData?.length > 0
                ? viewData.map((item, index) => {
                  return (
                    <div className="card">
                      <div key={index} className="card-body">
                        <div className="row pt-0">
                          <div className="col-md-3 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.followupBy} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {item.creator_name}
                            </label>
                          </div>
                        </div>
                        <hr />

                        <div className="row pt-0">
                          <div className="col-md-3 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.status} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {item.followup_status}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row pt-0">
                          <div className="col-md-3 align-items-center ">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.date} & {strings.time} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center ">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {item.followup_date
                                ? moment(item.followup_date).format(
                                  "DD-MM-YYYY, h:mm a"
                                ) :strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row pt-0">
                          <div className="col-md-3 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.description} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {item.remark ? item.remark : strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr className="className-1" />
                      </div>
                    </div>
                  );
                })
                : strings.notavailable}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AllFollowUp;
